import { ASSET_TYPE, DivWithTooltip, IAsset, assetIsDatalake, assetLinkProps, getAssetImage } from '@desp-aas/desp-ui-fwk';
import { icons, sourceMeta } from '../../utils/icons';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { createPortal } from 'react-dom';
import { BsDatabase, BsBraces, BsDisplay, BsFileText, BsMortarboard, BsHeart, BsDownload } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import removeMarkdown from 'remove-markdown';
import './AssetCardNew.css';

const TYPE_META: Record<string, { icon: React.ReactNode; color: string; label: string }> = {
    [ASSET_TYPE.dataset]:     { icon: <BsDatabase />,  color: 'rgb(239,43,137)',  label: 'Dataset' },
    [ASSET_TYPE.model]:       { icon: <BsBraces />,    color: 'rgb(123,52,219)',  label: 'Model' },
    [ASSET_TYPE.application]: { icon: <BsDisplay />,    color: 'rgb(20,143,150)',  label: 'Application' },
    [ASSET_TYPE.paper]:       { icon: <BsFileText />,  color: 'rgb(247,164,56)',  label: 'Document' },
    [ASSET_TYPE.course]:      { icon: <BsMortarboard />, color: 'rgb(99,193,224)', label: 'Course' },
};

type IProps = {
    asset: IAsset
};

export function AssetCardNew(props: IProps) {
    const { asset } = props;
    const [imgError, setImgError] = useState(false);
    const meta = TYPE_META[asset.type] ?? TYPE_META[ASSET_TYPE.dataset];
    const desc = removeMarkdown(asset.metadata?.description ?? '').trim();
    const shortDesc = desc.length > 95 ? desc.slice(0, 95) + '…' : desc;
    const cssVars = { '--acn-color': meta.color } as React.CSSProperties;
    const source = sourceMeta(asset.source);

    const tooltipId = `acn-src-${asset.id}`;

    return (
        <NavLink {...assetLinkProps(asset)} className="acn" style={cssVars}>
            <span
                className={`acn-source-badge acn-source-badge--${source.modifier}`}
                data-tooltip-id={tooltipId}
                data-tooltip-content={source.label}
            >
                {source.icon}
            </span>
            {createPortal(
                <Tooltip id={tooltipId} place="left" positionStrategy="fixed" />,
                document.body
            )}
            {asset.isBookmarked &&
                <DivWithTooltip tooltip="Bookmarked" className="acn-bookmark-badge">
                    {icons.assets.isBookmarked}
                </DivWithTooltip>
            }
            <div className="acn-img" data-type={asset.type}>
                {!imgError
                    ? <img src={getAssetImage(asset)} alt={asset.name} className="acn-real-img" onError={() => setImgError(true)} />
                    : <span className="acn-img-watermark">{meta.icon}</span>
                }
                <div className="acn-img-overlay" />
            </div>
            <div className="acn-body">
                <div className="acn-type-badge"><span className="acn-type-icon">{meta.icon}</span>{meta.label}</div>
                <div className="acn-name">{asset.name}</div>
                {desc && <div className="acn-desc">{shortDesc}</div>}
                {/* datalake assets have no local likes/downloads to show */}
                {!assetIsDatalake(asset) &&
                    <div className="acn-footer">
                        <span className="acn-stat"><BsHeart /> {asset.likes_count ?? 0}</span>
                        <span className="acn-stat"><BsDownload /> {asset.downloads_count ?? 0}</span>
                    </div>
                }
            </div>
        </NavLink>
    );
}

export default AssetCardNew;
